import { Box, Flex, Image, SimpleGrid, useBreakpointValue } from "@chakra-ui/react";
import EchartsComponent, { MyChartOptions } from "../echartsComponent";
import NewImg from "@/assets/images/creator_img3.png";
import { WorkInfo } from "@/types/creatorcenter";

type Props = {
  workInfo: WorkInfo;
}
const WorksDataItem = (props:Props) => {

  const {workInfo} = props;

  return (
    <Flex gap={"40px"} flexWrap="wrap">
          <Box width={"268px"}>
            <Image boxSize={"268px"} src={workInfo.image_url} />
            <Box
              style={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2, // 限制为两行
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              mt="10px"
              fontSize={"14px"}
              color={"#333333"}
            >
              {workInfo.intro}
            </Box>
            <Box fontSize={"12px"} color={"#B9B9B9"}>
              发布于 {workInfo.publish_time}
            </Box>
          </Box>
          <Box flex={1} minW="360px">
            <SimpleGrid columns={7} maxW="1050px" mb="50px">
              <Box>
                <Box color={"#8E94A9"} fontSize="12px">观看量</Box>
                <Box color={"#333C58"} fontSize="18px" fontFamily="Allerta">{workInfo.page_view}</Box>
              </Box>
              <Box>
                <Box color={"#8E94A9"} fontSize="12px">评论数</Box>
                <Box color={"#333C58"} fontSize="18px" fontFamily="Allerta">{workInfo.comment_num}</Box>
              </Box>
              <Box>
                <Box color={"#8E94A9"} fontSize="12px">点赞量</Box>
                <Box color={"#333C58"} fontSize="18px" fontFamily="Allerta">{workInfo.like_num}</Box>
              </Box>
              <Box>
                <Box color={"#8E94A9"} fontSize="12px">分享数</Box>
                <Box color={"#333C58"} fontSize="18px" fontFamily="Allerta">{workInfo.share_num}</Box>
              </Box>
              <Box>
                <Box color={"#8E94A9"} fontSize="12px">收藏量</Box>
                <Box color={"#333C58"} fontSize="18px" fontFamily="Allerta">{workInfo.collect_num}</Box>
              </Box>
              <Box>
                <Box color={"#8E94A9"} fontSize="12px">涨粉数</Box>
                <Box color={"#333C58"} fontSize="18px" fontFamily="Allerta">{workInfo.fans_num}</Box>
              </Box>
              <Box>
                <Box color={"#8E94A9"} fontSize="12px">被同款数</Box>
                <Box color={"#333C58"} fontSize="18px" fontFamily="Allerta">{workInfo.onekey_nums}</Box>
              </Box>
            </SimpleGrid>
            <Box h="240px">
              <EchartsComponent chartsOption={workInfo.lineOption} />
            </Box>
          </Box>
        </Flex>
  )
}

export default WorksDataItem;